// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3WKxz","signatureBlock":"Footer_signatureBlock__DBeqb","signature":"Footer_signature__1QiOi"};